import { Alert } from '@trussworks/react-uswds';

export const getCertifySignSubmitV1 = () => {
  return {
    headerText: 'Certify, Sign, and Submit',
    headerSubText: (
      <span className='text-bold'>
        This request must be signed by the person who desires to undertake the proposed activity (applicant) or it may
        be signed by a duly authorized agent if a completed agent authorization is provided.
      </span>
    ),

    resultBanner: ({ resultMessage, actionMessage }: { resultMessage: string; actionMessage: string }) => (
      <Alert className='margin-top-1' heading='RESULT' headingLevel='h5' type='warning' noIcon>
        Based on the answers you have provided to the questionnaire, your project{' '}
        <span className='text-bold'>{resultMessage}</span>.
        <div className='margin-top-1' />
         Upon submitting this request, you will be presented with an option to{' '}
        <span className='text-bold'>{actionMessage}</span>.
      </Alert>
    ),

    notAuthorizedBanner: ({ requestOwner }: { requestOwner: { firstName: string; lastName: string } }) => (
      <Alert headingLevel='h5' slim className='margin-top-3 margin-bottom-3' type='warning'>
        You are not authorized to Certify, Sign and Submit this request. Only the{' '}
        <span className='text-bold'>
          Request Owner: {requestOwner?.firstName} {requestOwner?.lastName}
        </span>{' '}
        can perform this operation.
      </Alert>
    ),

    agreeHeading: 'BY SUBMITTING THIS REQUEST, I AM AGREEING TO ALL OF THE FOLLOWING:',
    agreeBullets: ({ showAgentBullet }: { showAgentBullet: boolean }) => (
      <ul>
        <li>
          I consent to conduct business electronically and understand this consent can be withdrawn at any time in
          writing to the local USACE Regulatory office.
        </li>
        <li>
          By signing this request, I certify that the information contained in this request and any attached documents
          are true and correct to the best of my knowledge.
        </li>
        {showAgentBullet && (
          <li>
             I understand that, as an agent, I am providing this information on behalf of my client on a voluntary basis
            to help facilitate a more efficient review of the project.
          </li>
        )}
        <li>
          I understand that, whoever, in any matter within the jurisdiction of any department of agency of the United
          States, knowingly and willfully (1) falsifies, conceals, or covers up by any trick, scheme, or device a
          material fact; (2) makes any materially false, fictitious, or fraudulent statement or representation; or (3)
          makes or uses any false writing or document knowing the same to contain any materially false, fictitious, or
          fraudulent statement or entry; shall be fined not more than $10,000 or imprisoned not more than 5 years or
          both. (18 USC Section 1001)
        </li>
        <li>
          I understand that by typing my name in the text field below that I am e-signing this application and I
          understand that this e-signature has the same legal status as handwritten signatures.
        </li>
      </ul>
    ),
  };
};
